var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanknote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.8333H25M0 24.1666H25M4.16667 6.66659V4.16659H6.66667M18.3333 4.16659H20.8333V6.66659M4.16667 11.6666V14.1666H6.66667M18.3333 14.1666H20.8333V11.6666M12.5 12.4999C10.6591 12.4999 9.16667 11.0075 9.16667 9.16659C9.16667 7.32564 10.6591 5.83325 12.5 5.83325C14.3409 5.83325 15.8333 7.32564 15.8333 9.16659C15.8333 11.0075 14.3409 12.4999 12.5 12.4999ZM2.5 0.833252H22.5C23.4205 0.833252 24.1667 1.57944 24.1667 2.49992V15.8333C24.1667 16.7537 23.4205 17.4999 22.5 17.4999H2.5C1.57953 17.4999 0.833333 16.7537 0.833333 15.8333V2.49992C0.833333 1.57944 1.57953 0.833252 2.5 0.833252Z",
    stroke: "#FECA0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknote);
export default __webpack_public_path__ + "static/media/banknote.3a71ebfb787f9d89deb5d56a58d2aa48.svg";
export { ForwardRef as ReactComponent };